export enum TRACKER_PERMISSIONS {
  TRACKER_INTEGRATION_ASSISTANT = 'INTEGRATION_TRACKERASSISTANT',
  TRACKER_INTEGRATION_CONFIG = 'INTEGRATION_TRACKERCONFIG',
}
